import { ChevronsUpDown } from "lucide-react";
import { useAuth } from "@/auth/AuthProvider";
import { useSite } from "@/lib/queries";
import { t } from "@/i18n/id";

export function initialsOf(name: string, email?: string): string {
  const src = name.trim() || email || "?";
  const parts = src.split(/\s+/).filter(Boolean);
  return ((parts[0]?.[0] ?? "") + (parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "")).toUpperCase() || "?";
}

/** Same look as the menu triggers while their chunk loads (no layout shift). */
export function AvatarFallback() {
  const { user } = useAuth();
  return (
    <span className="grid size-10 place-items-center rounded-full bg-gradient-to-br from-brand-500 to-brand-700 text-[13px] font-bold text-white ring-2 ring-white shadow-sm" aria-label={t.shell.userMenu}>
      {initialsOf(user?.name ?? "", user?.email)}
    </span>
  );
}

export function SwitcherFallback({ siteId }: { siteId: string }) {
  const { data } = useSite(siteId);
  return (
    <span className="flex h-10 min-w-0 max-w-[48vw] items-center gap-1.5 rounded-pill px-3 text-sm font-semibold text-slate-800 sm:max-w-xs">
      <span className="truncate">{data?.name ?? "…"}</span>
      <ChevronsUpDown className="size-4 shrink-0 text-slate-400" aria-hidden="true" />
    </span>
  );
}
